import React, { useState } from 'react';
import Button from "./Button";
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import { List, ListItem } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from "@material-ui/core";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    bottom: {
        bottom: "0px",
        display: "flex",
        justifyContent: "center",
    },
}));
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    borderRadius: "25px",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    padding: "2%"
};
function Cart({ cart, removeEl, resetCart }) {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const [disabled, setDisabled] = useState(true)
    const [address, setAddress] = useState({
        email: "",
        via: "",
        numero: "",
        citta: "",
        provincia: "",
        cap: ""
    })

    const getMeasure = (elm) => elm === "Olio" ? "Lt" : "Kg"
    const getTotalPrice = (p, q) => p * q

    const handleOpen = () => {
        setDisabled(true)
        setOpen(!open)
    }

    const handleAddressChange = (prop) => (e) => {
        setAddress({ ...address, [prop]: e.target.value })
        checkAddress(address)
    }

    const checkAddress = (address) => {
        if (Object.values(address).every(i => i !== "")) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }

    const getTot = () => {
        return Object.keys(cart).reduce((c, key) => {
            return c + cart[key].price * cart[key].quantity
        }, 0)
    }

    const checkEmail = () => {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return address.email === ""
            ? false
            : !re.test(String(address.email).toLowerCase())

    }

    const checkNum = (type) => {
        return type === "num" && address.cap !== ""
            ? isNaN(address.numero)
            : isNaN(address.cap)
    }

    const handleConfirmOrder = () => {
        //send email confirmation
        //reset cart
        resetCart()
        setDisabled(true)
        setOpen(!open)

    }

    return (
        <div className={classes.container}>
            <Modal
                open={open}
                onClose={handleOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h3>Compila i seguenti campi obbligatori</h3>
                    <div style={{ width: "100%" }}>
                        <TextField
                            error={checkEmail()}
                            id="outlined-password-input"
                            label="email"
                            type="text"
                            style={{ width: "100%", margin: "5px" }}
                            onChange={handleAddressChange("email")}
                            helperText="Deve essere della forma: miaemail@dominio.it"
                        />
                        <TextField
                            id="outlined-password-input"
                            label="via/piazza"
                            type="text"
                            style={{ width: "300px", margin: "5px" }}
                            onChange={handleAddressChange("via")}
                        />
                        <TextField
                            error={checkNum("num")}
                            id="outlined-password-input"
                            label="numero"
                            type="text"
                            style={{ width: "80px", margin: "5px" }}
                            onChange={handleAddressChange("numero")}
                        />
                        <TextField
                            id="outlined-password-input"
                            label="città"
                            type="text"
                            style={{ width: "200px", margin: "5px" }}
                            onChange={handleAddressChange("citta")}
                        />
                        <TextField
                            id="outlined-password-input"
                            label="provincia"
                            type="text"
                            style={{ width: "100px", margin: "5px" }}
                            onChange={handleAddressChange("provincia")}
                        />
                        <TextField
                            error={checkNum("cap")}
                            id="outlined-password-input"
                            label="cap"
                            type="text"
                            maxLength={5}
                            style={{ width: "150px", margin: "5px" }}
                            onChange={handleAddressChange("cap")}
                            helperText="Deve essere un numero"
                        />
                    </div>

                    <p style={{ marginBottom: "5px" }}>Confermando ricevereai un email di conferma ordine entro 24h.</p>
                    <p style={{ marginBottom: "5px", marginTop: "5px" }}>L'importo {getTot().toFixed(2)} verrà al momento della consegna. </p>
                    <p style={{ marginTop: "5px" }}>Assicurati di avere la cifra esatta al momento della consegna del pacco!</p>

                    <div>
                        <Button name="Conferma" disabled={disabled} onClick={() => handleConfirmOrder()} />
                        <Button name="Annulla" style={{ float: "right" }} onClick={() => setOpen(!open)} />
                    </div>
                </Box>
            </Modal>

            <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
                <AddShoppingCartIcon />
                <b style={{ margin: "10px", }}>Carrello</b>
            </div>

            <List style={{ width: "100%" }}>
                {!!cart && Object.keys(cart).map((element, i) => (
                    <ListItem key={i} style={{ width: "100%", borderBottom: "2px solid black" }}>
                        <IconButton style={{ width: "50px", height: "50px" }} onClick={() => removeEl(element)}>
                            <DeleteIcon size="large" />
                        </IconButton>
                        <p>{element}</p>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            float: "right",
                            flexDirection: "row",
                            marginLeft: "auto",
                        }}>
                            <p style={{ marginRight: "20px" }}>{cart[element].price.toFixed(2)} €/{getMeasure(element)}</p>
                            <p style={{ marginRight: "20px" }}>x{cart[element].quantity}</p>
                            <b >{getTotalPrice(cart[element].price, cart[element].quantity).toFixed(2)} €</b>
                        </div>
                    </ListItem>
                ))}
            </List>
            <h3 style={{ display: "flex", float: "right", marginLeft: "auto", marginRight: "20px" }}> TOT. {getTot().toFixed(2)}€</h3>
            
            <div className={classes.bottom} >
                <Button name="Acquista" onClick={() => setOpen(!open)} />
            </div>
        </div>
    )
}

export default Cart;
